"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    infoRow: {
        fontSize: 12,
        borderBottom: `1px solid ${globalStyle_1.default.grey4}`,
        color: globalStyle_1.default.grey2,
        paddingBottom: 2,
        marginBottom: 2,
        minWidth: 140
    }
};
//# sourceMappingURL=profileInfo.style.js.map